import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'sort'
})

export class SortPipe implements PipeTransform {
  transform(array: any[], field: string, shouldSort: boolean, ascending=true): any[] {
    if (!Array.isArray(array) || !field || !shouldSort) {
      return array;
    }

    return array.sort((a, b) => {
      if (a[field] < b[field]) {
        return ascending ? -1 : 1;
      } else if (a[field] > b[field]) {
        return ascending ? 1 : -1;
      } else {
        return 0;
      }
    });
  }
}
